import React, { useContext, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EditIcon from "@mui/icons-material/Edit";
import SearchIcon from "@mui/icons-material/Search";
import DataContext from "../../../context/DataContext";
import TablePagination from "@mui/material/TablePagination";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import apiService from "../../../api/apiService";
import downloadExcel from "../../../hooks/downloadExcel";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
import Menu from "@mui/material/Menu";
import Button from "@mui/material/Button";
import notifyService from "../../../api/notifySerivce";
import { Autocomplete, Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormHelperText, Grid, Modal, TextField, Tooltip } from "@mui/material";
import SendEmail from "../../admin-module/startup-page/SendEmail";
import { Controller, useForm } from "react-hook-form";
import CustomLink from "../../common-page/CustomLink";
import { IconButton } from "@mui/material";
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import {
    FirstPage,
    KeyboardArrowLeft,
    KeyboardArrowRight,
    LastPage,
} from "@mui/icons-material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import SendEmailAdmin from "../../admin-module/startup-page/SendEmailAdmin";
import { useNavigate, useParams } from "react-router-dom";

const SearchinputDiv = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: "beige",
    "&:hover": {
        backgroundColor: "beige",
    },
    color: "black",
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
        marginLeft: theme.spacing(1),
        width: "auto",
    },
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));
const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create("width"),
        width: "100%",
        [theme.breakpoints.up("sm")]: {
            width: "23ch",
            "&:focus": {
                width: "25ch",
            },
        },
    },
}));

const DynamicUserFormList = () => {
    const { open, modalstyle, setPageLoading, tableIndexValue, isWhitespace } =
        useContext(DataContext);
           const { id } = useParams()
             let userId
            if(id !== undefined ) {
               userId = atob(id)
                debugger
              }
    const [formData, setFormData] = useState({});
    const { handleSubmit, control, setValue, watch, reset, clearErrors, getValues, formState: { errors } } = useForm(
        { values: formData, }
    );
    const navigate = useNavigate();
    const [partnerListData, setPartnerListData] = useState([]);
    const [count, setCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [activeStartup, setActiveStartup] = useState(1);
    const [acceptTanseed, setAcceptTanseed] = useState(true);
     var searchInputValuePartners = localStorage.getItem(
    "dynamicCustomFormSearch"
  );
    const [searchInputValue, setSearchInputValue] = useState(searchInputValuePartners ? searchInputValuePartners : "");
  const [searchName, setSearchName] = useState(searchInputValuePartners ? searchInputValuePartners : "");
    useDidMountEffect(() => {
        userListItemTanseed();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        page,
        rowsPerPage,
        searchInputValue,
        activeStartup,
        acceptTanseed,
    ]);
  
    const handleSearch = (searchValue) => {
        if (searchValue.length > 2) {
            setSearchInputValue(searchValue);
            // localStorage.setItem("dynamicCustomFormSearch", searchValue);
            setPage(0);
        } else {
            setSearchInputValue("");
            // localStorage.setItem("dynamicCustomFormSearch", "");
            setPage(0);
        }
        setSearchName(searchValue);
    };
    const userListItemTanseed = async () => {
        setPageLoading(true);
        setPartnerListData([]);
        var reqTanseed = {
            listSize: rowsPerPage,
            pageNumber: page + 1,
            searchString: searchInputValue,
            configId: userId,
        };
        await apiService("admin/custom/form/startups/list", reqTanseed, "post").then(
            (res) => {
                setPageLoading(false);
                if (res) {
                    setCount(res.data.count);
                    if (res.data.startups) {
                        setPartnerListData(res.data.startups);
                    } else {
                        setPartnerListData([]);
                    }
                }
            }
        );
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // const [loading, setLoading] = useState(false);
    const exportExcelStartup = (download, emails) => {
        setPageLoading(true);
        var req;
        if (download === "All") {
            req = {
                download: download,
                searchString: searchInputValue,
                emails: emails,
                listSize: rowsPerPage,
                pageNumber: page + 1,
                configId: userId,
            };
        } else {
            req = {
                emails: emails,
                download: download,
                listSize: rowsPerPage,
                pageNumber: page + 1,
                searchString: searchInputValue,
                configId: userId,
            };
        }
        apiService("admin/custom/form/startups/list", req, "downloadpost").then((res) => {
            setPageLoading(false);
            if (res) {
                if (res.data) {
                    // if (res.data.byteLength === 169) {
                    //     notifyService("danger", "TANSEED list is empty", "");
                    // } else {
                    //     notifyService(
                    //         "success",
                    //         "Success",
                    //         "An Excel file has been sent to email."
                    //     );
                    //     handleExportAllClose();
                    // }
                    notifyService(
                            "success",
                            "Success",
                            "An Excel file has been sent to email."
                        );
                        handleExportAllClose();
                }
            }
        });
    };
  

    const [openAllExport, setopenAllExport] = useState(false);
    const handleExportAllClick = () => {
        setopenAllExport(true);
    };
    const handleExportAllClose = () => {
        setopenAllExport(false);
    };
    return (
        <>
            <div className="scsthub-div form_div chart">
                <div className="table_tag">
                    <div className="table_header_tag set-res-flex ml-auto">
                        <SearchinputDiv
                            sx={{ display: { xs: "none", sm: "block" } }}
                            onChange={(e) => handleSearch(e.target.value)}
                        >
                            <SearchIconWrapper>
                                <SearchIcon />
                            </SearchIconWrapper>
                            <StyledInputBase
                                value={searchName}
                                type="search"
                                placeholder="Search for a Startup"
                                inputProps={{ "aria-label": "search" }}
                            />
                        </SearchinputDiv>
                        {partnerListData.length > 0 && (
                        <div className="ml-auto">
                            <div className="d-flex align-item-center">
                                <Button
                                    className="ml-md-3"
                                    variant="outlined"
                                    onClick={handleExportAllClick}
                                    startIcon={<CloudDownloadIcon />}
                                >
                                    Export
                                </Button>
                            </div>
                        </div>)}
                    </div>
                    {partnerListData.length ? (
                        <TableContainer component={Paper}>
                            <Table aria-label="caption table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>No</TableCell>
                                        <TableCell>Startup Name</TableCell>
                                        <TableCell>Application Number</TableCell>

                                        <TableCell>Email</TableCell>
                                        <TableCell>Phone Number</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {partnerListData.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell>
                                                {tableIndexValue(rowsPerPage, page, index)}
                                            </TableCell>
                                            <TableCell>
                                                {/* {row.name} */}
                                                <CustomLink
                                                    to={`/dynamic-form/tanfund/details/${btoa(row.startupId)}/${btoa(row.configId)}`}
                                                >
                                                    {row.startupName ? row.startupName : `-`}
                                                </CustomLink>
                                            </TableCell>
                                            <TableCell>{row.applicationNo ? row.applicationNo : `-`}</TableCell>
                                            <TableCell>{row.email ? row.email : `-`}</TableCell>
                                            <TableCell>{row.phone ? row.phone : `-`}</TableCell>

                                        </TableRow>
                                    ))}
                                </TableBody>
                                <caption>
                                    <TablePagination
                                        component="div"
                                        count={count}
                                        page={page}
                                        onPageChange={handleChangePage}
                                        rowsPerPage={rowsPerPage}
                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                        style={{ float: "left" }}
                                        ActionsComponent={(paginationProps) => (
                                            <CustomTablePaginationActions {...paginationProps} />
                                        )}
                                    />
                                </caption>
                            </Table>
                        </TableContainer>
                    ) : (
                        <div className="nodata_tag">
                            <img
                                src="/images/Tanfundlogo-black-1.png"
                                className="no_data_logo"
                                alt=""
                            />
                            <h4>No Records Found</h4>
                        </div>
                    )}
                </div>
                <Modal open={openAllExport}>
                    <Box sx={modalstyle} className="form_tag">
                        <SendEmail
                            handleExportAllClose={handleExportAllClose}
                            exportExcelStartup={exportExcelStartup}
                        />
                    </Box>
                </Modal>
            </div>

        </>
    );
};

export default DynamicUserFormList;
function CustomTablePaginationActions(props) {
    const { count, page, rowsPerPage, onPageChange } = props;
    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div style={{ flexShrink: 0, marginLeft: "1rem" }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                <FirstPage />
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                <KeyboardArrowLeft />
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                <KeyboardArrowRight />
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                <LastPage />
            </IconButton>
        </div>
    );
}
